import React from 'react';
import {TableCellBaseProps} from "@material-ui/core";

interface CollapsibleTableCellProps extends TableCellBaseProps {
  content: any[];
}

const MultilineTableCell = (props: CollapsibleTableCellProps) => {

  return (
      <>
        {props.content.filter(Boolean).map((c, idx: number) => (<p key={idx + (typeof c === 'string' ? c : '')}>{c}</p>))}
      </>
  );
};

export default MultilineTableCell;